import React from 'react';

import { useCurrentTheme } from 'app/shared/theme';
import { preserveLineBreaks } from 'app/shared/utils/string';
import { useMerchandisingHeadlineAndDescription } from 'app/shared/utils/useMerchandisingHeadlineAndDescription';
import { Event } from 'app/shared/typings';
import {
  Box,
  DynamicHtmlContent,
  Typography,
} from 'app/shared/components/atoms';

interface AddressLinkProps {
  event?: Event;
}

export const AboutConcert: React.FC<
  React.PropsWithChildren<AddressLinkProps>
> = ({ event }) => {
  const { colors } = useCurrentTheme();

  const aboutThisConcert = useMerchandisingHeadlineAndDescription({ event });
  if (!event) {
    return null;
  }

  return (
    <Box>
      <Box h="100%" pt={6} flexDirection="column">
        <Typography
          fontSize="fontSize500"
          fontWeight="medium"
          fontFamily="title"
          as="h4"
          m={0}
          color={colors.primary.white.base}
        >
          {aboutThisConcert.headline}
        </Typography>
        {aboutThisConcert.description && (
          <DynamicHtmlContent
            m={0}
            pt={2}
            fontSize="fontSize300"
            color={colors.primary.white.base}
            linkVariant="primary"
            dangerouslySetInnerHTML={{
              __html: preserveLineBreaks(aboutThisConcert.description),
            }}
          />
        )}
      </Box>
    </Box>
  );
};
